"use strict";
/*!
 *
 *  menu.ts
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var load_image_1 = __importDefault(require("load-image"));
var Gallery = /** @class */ (function () {
    function Gallery(elem, option) {
        this.class = {
            main: 'tp-Hero_Main',
            loader: 'tp-Hero_Loader',
            img: 'tp-Hero_Image',
            play: 'tp-Hero-play',
            next: 'tp-Hero_Image-next',
            current: 'tp-Hero_Image-current'
        };
        this.$elem = $(elem);
        this.class = $.extend({}, this.class, option);
        this.$main = this.$elem.find('.' + this.class.main);
        this.$loader = this.$elem.find('.' + this.class.loader);
        this.$item = this.$elem.find('.' + this.class.img);
        this.max = this.$item.length;
        this.counter = this.$item.length + 1;
        this.$current = this.$item.filter(function () {
            return $(this).is(':first-child');
        });
        this.$next = this.$current.next();
        this.load();
    }
    Gallery.prototype.load = function () {
        var _this = this;
        this.$current.toggleAria('hidden');
        this.$next.toggleAria('hidden');
        this.$loader[0].addEventListener('transitionend', function (e) {
            if (e.propertyName === 'opacity') {
                _this.play();
            }
            ;
        });
        $(window).on('CSSLoad', function () {
            if (--_this.counter === 0) {
                _this.loaded();
            }
            ;
        });
        this.$item.each(function (i, elem) {
            if (i === 0) {
                $(elem).addClass(_this.class.current);
            }
            ;
            if (i === 1) {
                $(elem).addClass(_this.class.next);
            }
            ;
            var src = $(elem).find('img').attr('src');
            var promise = load_image_1.default(src);
            promise.done(function () {
                if (--_this.counter === 0) {
                    _this.loaded();
                }
                ;
            });
        });
    };
    Gallery.prototype.loaded = function () {
        this.$elem.attr('aria-busy', 'false');
        $(window).trigger('scroll');
    };
    Gallery.prototype.play = function () {
        var _this = this;
        if (this.max > 1) {
            this.$elem.addClass(this.class.play);
        }
        ;
        this.$item.each(function (i, elem) {
            elem.addEventListener('transitionend', function (e) {
                if ($(e.currentTarget).is('.' + _this.class.current) && e.propertyName === 'opacity') {
                    _this.switch();
                }
                ;
            });
        });
    };
    Gallery.prototype.switch = function () {
        this.$next.removeClass(this.class.next).addClass(this.class.current);
        this.$current.toggleAria('hidden').removeClass(this.class.current);
        this.$current = this.$next;
        this.$next = this.$current.next();
        if (this.$next.length === 0) {
            this.$next = this.$item.filter(function () {
                return $(this).is(':first-child');
            });
        }
        ;
        this.$next.toggleAria('hidden').addClass(this.class.next);
    };
    return Gallery;
}());
;
$.fn.gallery = function (option) {
    var opt = option ? option : {};
    return this.each(function (i, elem) {
        new Gallery(elem, opt);
    });
};
